import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Params} from '@angular/router';
import {SharedService} from '../../../shared/shared.service';
import {AuthenticationService, SocialLoginService} from '../../../_services';
import {Constants} from '../../../shared/Helpers/constants';
import { SocialProviderNameEnum } from 'src/app/enums/enums';

@Component({
  selector: 'app-linked-in-login-callback',
  templateUrl: './linked-in-login-callback.component.html'
})
export class LinkedInLoginCallbackComponent implements OnInit {
  public logoPath: any = null;
  private defaultReturnUrl = environment.default_return_url;
  public hideLogin: boolean = false;
  public linkCheckErrorMessage: boolean | any = null;

  constructor(
    private route: ActivatedRoute,
    public sharedService: SharedService,
    private authenticationService: AuthenticationService,
    private socialLoginService: SocialLoginService
  ) { }

  ngOnInit() {
    let code: any = null;
    let signUp: any = null;
    this.route.queryParams.subscribe((params: Params) => {
      code = params.code;
      signUp = params.signUp
    });

    if (signUp == undefined) {
      this.hideLogin = true;
    }
    if (code != undefined) {
      this.hideLogin = true;
      this.socialLoginService.getContextualizedTokenForGuestAccount(SocialProviderNameEnum.LinkedIn, code).subscribe({
        next: (res) => {
          if (res.status == 200) {
            const user = res.body;
            if (user && user.token) {
              localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
              this.authenticationService.redirect(this.defaultReturnUrl);
            }
          }
        },
        error: (err) => {
          this.linkCheckErrorMessage = err.error.detailedMessage;
        }
      });
    }
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  public onLoginWithLinkedInClick() {
    this.socialLoginService.socialLoginAuthorizationUrl(SocialProviderNameEnum.LinkedIn).subscribe((res: any) => {
      if (res) {
        window.location.href = res.toString();
      }
    });
  }

}
